import { useMemo } from 'react';
import { Select, SelectProps } from '../inputs/select';

export interface YearSelectorProps extends Omit<SelectProps, 'options'> {
  startYear: number;
  endYear: number;
}

export function YearSelector({ startYear, endYear, ...selectProps }: YearSelectorProps) {
  const years = useMemo(
    () =>
      Array.from({ length: endYear - startYear + 1 }, (_, i) => {
        const year = startYear + i;
        return { value: year.toString(), label: year.toString() };
      }),
    [startYear, endYear],
  );

  return <Select options={years} {...selectProps} />;
}
